import React, { useState } from "react";
import { IoIosArrowBack, IoIosArrowForward } from "../utils/Icons";

const Pagination = ({ currentPage, setCurrentPage, totalPages }) => {
  const getPageNumbers = () => {
    const pages = [];
    if (totalPages <= 7) {
      // Show all pages if there are less than or equal to 7 pages
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      if (currentPage <= 4) {
        pages.push(1, 2, 3, 4, 5, "...", totalPages);
      } else if (currentPage > totalPages - 4) {
        pages.push(
          1,
          "...",
          totalPages - 4,
          totalPages - 3,
          totalPages - 2,
          totalPages - 1,
          totalPages
        );
      } else {
        pages.push(
          1,
          "...",
          currentPage - 1,
          currentPage,
          currentPage + 1,
          "...",
          totalPages
        );
      }
    }
    return pages;
  };

  const handlePageClick = (page) => {
    if (page === "...") return;
    setCurrentPage(page);
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handleBack = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  return (
    <div className="flex justify-center items-center space-x-1 lg:space-x-3 px-[3%] lg:px-0 lg:mb-10">
      {/* Back Button */}
      <button
        onClick={handleBack}
        disabled={currentPage === 1}
        className={`p-2 rounded-xl ${
          currentPage === 1
            ? "bg-gray-100 font-normal text-base text-gray-300"
            : "bg-whiteColor font-normal text-base text-textPrimaryColor border border-primaryColor/50 shadow"
        }`}
      >
        <IoIosArrowBack />
      </button>

      {/* Page Numbers */}
      {getPageNumbers().map((page, index) => (
        <button
          key={index}
          onClick={() => handlePageClick(page)}
          className={`px-3 py-1.5 ${
            page === currentPage
              ? "bg-whiteColor font-normal text-sm text-textPrimaryColor border border-primaryColor/50 rounded-xl shadow"
              : "font-normal text-sm text-textPrimaryColor"
          }`}
        >
          {page}
        </button>
      ))}

      {/* Next Button */}
      <button
        onClick={handleNext}
        disabled={currentPage === totalPages}
        className={`p-2 rounded-xl ${
          currentPage === totalPages
            ? "bg-gray-100 font-normal text-base text-gray-300"
            : "bg-whiteColor font-normal text-base text-textPrimaryColor border border-primaryColor/50 shadow"
        }`}
      >
        <IoIosArrowForward />
      </button>
    </div>
  );
};

export default Pagination;
